import axios from '../../service/index'
import React, { Component } from 'react'
import {connect} from "react-redux";
import { Button, Divider, message, Form, Input,Radio, Checkbox,  Icon } from 'antd'
import Wangeditor from '../../commponents/wangeditor/index'
import './typetopic.less'
const FormItem = Form.Item
// const { TextArea } = Input;
// const qiniuUpUrl = 'https://up-z1.qiniup.com'
class TypeTopic extends Component {
  constructor(props) {
    super(props)
  this.state = {
    showKnowName: false,
    typeQ: 'add',
    topicType: 0,
    modelTitle: '新增知识点',
    editor: '',
    // contentObj: {
    type: '1',
    content: '',
    // }
    options: [{ label: 'Apple', value: 'Apple' },
    { label: 'Pear', value: 'Pear' },
    { label: 'Orange', value: 'Orange' }],
    checkboxList: [1,2],
    checkedList: [],
    listArr: [{sort:0,content: '',isRight: 1},{sort:1,content: '',isRight: 0}],
    letter: {1:'A',2:'B',3:'C',4:'D',5:'E',6:'F',7:'G',8:'H',9:'I',10:'J'},
    editorHtml: '',
    editorText: '',
    token: '',
    knowId: '',
    questionId: '',
    interviewId: '',
    subjectName: '',
    typebtn: '',
    pageNum: 1,
  }
}
  submitOk = (e) => {
    e.preventDefault();
    let {form} = this.props
    form.validateFields((err, values) => {
      if(!err) {
        let {typebtn, knowId, questionId, subjectName, interviewId, pageNum, typeQ, topicType} = this.state
        // 判断列表的设为答案个数
        let rightlength = []
        values.optionArr.filter((v,i) => {
          if(v.isRight === 1) {
            rightlength.push(this.state.letter[i+1])
          }
          return rightlength
        })
        if(topicType === 0&&rightlength.length!==1)return message.error('单选题一个答案')
        if(topicType === 1&&rightlength.length<2)return message.error('多选题至少两个答案')
        let {optionArr, analysis, content} = values
        let answer = rightlength.splice(',').join()
        let params = {questionOptions: optionArr,konwledgeId: knowId, subjectId: questionId, answer, analysis, content,type: values.topicType}
        if(typeQ === 'add'){
          delete params.id
        }else{
          params.id = interviewId
        }
        let url = typeQ === 'add' ? 'question/save' : 'question/update'
        axios.post(url, params).then(res => {
          if(res.data.code !== '200') return message.error(res.data.msg)
          message.success(`${typeQ === 'add'?'新增':'编辑'}成功`)
          this.props.form.resetFields();
          // this.state.editor.txt.html('<p><br></p>')
          this.setState({listArr:[{sort:0,content: '',isRight: 1},{sort:1,content: '',isRight: 0}]})
          if(typebtn === 'save'){
            this.props.backTabButton('1')
            this.props.history.push('/Test',{knowId, questionId,subjectName, pageNum})
          }
        })
      }
    })
  }
  
  saveLinkbtn = () => {
    this.setState({typebtn: 'save'})
  }
  cancelbtn = () => {
    let {knowId, questionId, subjectName, pageNum} = this.state
    this.props.backTabButton('1')
    this.props.form.resetFields();
    this.props.history.push('/Test',{knowId, questionId, subjectName, pageNum})
  }
  radioChange = (e) => {
    this.setState({topicType: e.target.value},() => {
      this.props.form.setFieldsValue({
        optionArr: [{sort:0,content: '',isRight: 1},{sort:1,content: '',isRight: 0}]
      })
    })
  }
  changeInput = (e, index) => {
    const {form} = this.props
    let keys = form.getFieldValue('optionArr')
    keys[index].content = e.target.value
    this.setState({optionArr: keys})
  }
  onanswerChange = (e,index) => {
    const {form} = this.props
    let keys = form.getFieldValue('optionArr')
    keys[index].isRight = keys[index].isRight === 0 ? 1 : 0
    this.setState({optionArr: keys})
  }
  addOptions = () => {
    const {form} = this.props
    let keys = form.getFieldValue('optionArr')
    console.log(keys, keys[keys.length-1].sort)
    if(keys.length>10)return message.error('上限10个')
    if ((keys && keys[keys.length - 1]) || keys === undefined) {
      const nextKeys = keys.concat({sort: keys[keys.length-1].sort+1,questionId: this.state.interviewId, content:'',isRight: 0})
      form.setFieldsValue({
        optionArr: nextKeys
      })
    }
  }
  removeOptions = (k) => {
    const { form } = this.props;
    const keys = form.getFieldValue('optionArr');
    if(keys.length<=2){
      return message.error('至少保留2个')
    }
    console.log(keys)
    form.setFieldsValue({
      optionArr: keys.filter(key => key.sort !== k.sort)
    })
  }
  getToken=() =>{
		let _this = this;
		axios.get("/uplodController/get7menrToken").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					token: res.data.data.token,
					url: res.data.data.url
				})
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}
  componentWillUnmount() {
    this.setState({typebtn: ''})
  }
  componentDidMount() {
    this.getToken()
    let {knowId, questionId,interviewId,subjectName, pageNum, typeQ} = this.props.location.state
    this.setState({knowId, questionId, interviewId, subjectName, typeQ, pageNum},() => {
      if(typeQ === 'edit'){
        this.getchooseInfo()
      }
    })

    // let editor = new E(ReactDOM.findDOMNode(this._div))

		// this.setState({ editor: editor })
		// editor.config.menus = [
		// 	'head',
		// 	'bold',
		// 	'fontSize',
		// 	'fontName',
		// 	'italic',
		// 	'underline',
		// 	'strikeThrough',
		// 	'indent',
		// 	'lineHeight',
		// 	'foreColor',
		// 	'backColor',
		// 	'link',
		// 	'list',
		// 	'todo',
		// 	'justify',
		// 	'quote',
		// 	'table',
		// 	'splitLine',
		// 	'undo',
		// 	'redo',
		// 	'image',
		// ]
    // editor.config.uploadImgMaxLength = 5;
		// editor.config.showLinkImg = false;
		// editor.config.uploadImgServer = "/upload"; //上传图片的server接口地址
		// editor.config.withCredentials = false;
		// editor.config.uploadImgTimeout = 5 * 1000;
    // let _this = this
    // editor.config.customUploadImg = function (resultFiles, insertImgFn) {
    //   // console.log(resultFiles)
		// 	let imgUrl = ''
		// 	let data = new FormData();
		// 	data.append("token", _this.state.token);
		// 	data.append("file", resultFiles[0]);
		// 	axios({
		// 		method: "POST",
		// 		url: qiniuUpUrl,
		// 		data: data,
		// 		onUploadProgress: function (progressEvent) {
		// 		},
		// 	}).then((res) => {
		// 		imgUrl = _this.state.url + '/' + res.data.key
		// 		insertImgFn(imgUrl);
		// 	});
		// };
    // editor.config.onchange = (html) => {
		// 	this.setState({
		// 		editorHtml: html,
		// 		editorText: editor.txt.text()
		// 	})
		// 	//将html值设为form表单的desc属性值
		// 	this.props.form.setFieldsValue({
		// 		'analysis': html
		// 	});
		// }
    // editor.create()
  }
  getchooseInfo() {
    let {interviewId} = this.props.location.state
    axios.get(`question/info/${interviewId}`).then(res => {
      if (res.data.code === '200') {
        let data = res.data.data
        this.setState({
          topicType: data.type, 
          content: data.content, 
          listArr: data.questionOptions, 
          analysis: data.analysis
        })
       // console.log(this.state.analysis)
        // this.state.editor.txt.html(data.analysis)
    }
    })
  }
  radioAnswer = (e) => {
    let {form} = this.props
    let optionArr = form.getFieldValue('optionArr').map((item, i) => {
      if(i=== e.target.value) {
        return Object.assign(item, {
          isRight: 1,
        })
      }
      return Object.assign(item, {
        isRight: 0,
      });
    })
    this.setState({optionArr: optionArr})
  }
  getText = v => {
   // console.log(v)
    this.props.form.setFieldsValue({
      'content': v
    });
	}
  getAnalysis= v => {
    //console.log(v)
    this.props.form.setFieldsValue({
      'analysis': v
    });
	}
  render() {
    let { typeQ, topicType,content,analysis, subjectName, listArr,knowId,questionId, letter } = this.state
    const tailLayout = {
      wrapperCol: { offset: 2, span: 12 },
    }
    const { getFieldDecorator, getFieldValue } = this.props.form;
    getFieldDecorator('optionArr', { initialValue: listArr||[] })
    const optionArr = getFieldValue('optionArr');
    const formItems = optionArr.map((k, index) => (
      <FormItem label={'选项'+letter[index+1]} key={index}>
        {getFieldDecorator(`name${k.sort}`, {
            validateTrigger: ['onChange', 'onBlur'],
            rules: [
              {
                required: true,
                whitespace: true,
                message: "请输入选项.",
              },
            ],
            initialValue: k.content
          })(<Input placeholder="请输入选项" onChange={(e) => {this.changeInput(e,index)}} maxLength={500} style={{  marginRight: 8 }} />)}
          
          {topicType === 0?
            <Radio.Group options={[{label:'设为答案',value:index}]} onChange={this.radioAnswer} value={k.isRight=== 1?index:''} />
            :
            <Checkbox onChange={(e) => {this.onanswerChange(e, index)}} checked={k.isRight=== 1?true:false}>设为答案</Checkbox>
          }
          {optionArr.length > 2 ? (
            <Icon
              className="dynamic-delete-button"
              type="minus-circle-o"
              onClick={() => this.removeOptions(k)}
            />
          ) : null}
      </FormItem>
    ))
    return (
      <div className="topic">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<span className="topic-title">{typeQ === 'add' ? '新增' : '编辑'}试题</span>
					<span className="my-button-txt" onClick={() => {
            this.props.backTabButton('1')
						this.props.history.push('/Test',{knowId, questionId, subjectName})
					}}>返回上一级</span>
				</div>
				<Divider />
          <Form labelCol={{ span: 2 }} wrapperCol={{ span: 12 }} onSubmit={this.submitOk}>
          <FormItem label="题型" name="topicType">
            {getFieldDecorator('topicType', {
              rules: [
                {required: true,message: '请选择题型'},
              ],
              initialValue: typeQ === 'edit'?topicType:0
              })(
              <Radio.Group disabled={typeQ === 'edit'?true: false} onChange={this.radioChange}>
                <Radio value={0}>单选题</Radio>
                <Radio value={1}>多选题</Radio>
              </Radio.Group>)}
						</FormItem>
            {/* <FormItem label="题干" name="content">
              {getFieldDecorator('content', {
              rules: [
                {required: true,message: '请输入题干'},
                {max: 500,message: '最多输入500个字!'}
              ],
              initialValue: typeQ === 'edit'?content:''
              })(<TextArea rows={4} maxLength="500" />)}
						</FormItem> */}
            <FormItem label="题干" name="content">
              {getFieldDecorator('content', {
                rules: [
                  {required: true,message: '请输入题干'},
                  {max: 500,message: '最多输入500个字!'}
                ],
                initialValue: typeQ === 'edit' && content ? content : ''
              })(
                // <div ref={(ref) => this._div = ref}></div>
                <Wangeditor content={content}  getText={this.getText}/>
              )}
              </FormItem>
              {formItems}
              <FormItem style={{display: optionArr.length===10?'none':'block'}} {...tailLayout} className="add-btn">
                  <Button type="primary" ghost onClick={this.addOptions} style={{ width: '60%' }}>
                    <Icon type="plus" /> 添加选项
                  </Button>
              </FormItem>
              <FormItem label="答案解析：" name="analysis">
              {getFieldDecorator('analysis', {
                initialValue: typeQ === 'edit' && analysis ? analysis : ''
              })(
                // <div ref={(ref) => this._div = ref}></div>
                <Wangeditor content={analysis}  getText={this.getAnalysis}/>
              )}
              </FormItem>
              <Form.Item {...tailLayout}>
              <Button onClick={this.cancelbtn}>
                取消
              </Button>
                <Button type="primary" className="mar-btn" htmlType="submit" onClick={this.saveLinkbtn}>
                  保存
                </Button>
                <Button style={{display:typeQ === 'add'?'block':'none'}} type="primary" htmlType="submit">
                  保存并继续添加
                </Button>
              </Form.Item>
					</Form>
      </div>
    )
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    backTabButton(num) {
       let action = {
        type: 'tabChange',
        value: num
      }
      dispatch(action)
    }
  }
}
export default Form.create()(connect(null, mapDispatchToProps)(TypeTopic))